<template>
  <router-view />
</template>

<script>
export default {
  name: "CropProgressionIndex",
};
</script>
